/**
 * Hub のヒーロー・認証ページ等で使う背景エフェクトの共通設定
 * ColorBends のデフォルト props を一箇所で管理
 */

export const COLOR_BENDS_DEFAULT_PROPS = {
  colors: ['#ff5c7a', '#8a5cff', '#00ffd1'],
  rotation: 124,
  speed: 0.2,
  scale: 1.5,
  frequency: 1,
  warpStrength: 0.95,
  mouseInfluence: 1,
  parallax: 0.5,
  noise: 0,
  transparent: false,
  autoRotate: 0,
};
